/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetDashboardPolicySparklineParams = zod.object({
	start: zod.string(),
	end: zod.string()
});

export type GetDashboardPolicySparklineParams = zod.input<typeof GetDashboardPolicySparklineParams>;
export type GetDashboardPolicySparklineParamsOutput = zod.output<
	typeof GetDashboardPolicySparklineParams
>;
